import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail6 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            Python 基本與進階資料類型，涵蓋(int, string, float, boolean, dict,
            set, list, and tuples)
          </li>
          <li>Python 運算、控制流程與 Pythonic 語法</li>
          <li>I/O 文件處理</li>
          <li>實做 Error Handling</li>
          <li>解析模組(Module)和套件(Package)的概念</li>
          <li>使用正規表示式(regular expressoin)處理大型資料的接收與分析</li>
          <li>使用requests以及beautiful soup模組製作網路爬蟲</li>
          <li>製作Python TypedList</li>
          <li>使用Pylint以及Unittest 透過sqlalchemy連結資料庫</li>
          <li>透過smtplib接收以及寄送電子郵件 使用Jython處理圖片</li>
          <li>學習基本的Flask製作網頁伺服器</li>
          <li>學習基礎Tkinter語法，製作初階桌面應用程式</li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對學習Python或程式語言有興趣的初學者</li>
          <li>
            對資料科學、數據分析、資料視覺化、機器學習、深度學習有興趣的有經驗者
          </li>
          <li>大學資工系、資管系主修或副修學生</li>
          <li>想要轉職成為工程師的在職者</li>
          <li>想要考資工研究所的學生</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail6;
